import { call, put, takeLatest } from "redux-saga/effects";
import { bsReportsFailure, bsReportsStart, bsReportsSuccess } from "./bsReportsSlice";
import { fetchBsReportsApi } from "./bsReportsApi";

function* fetchBsReportsWorker(action) {
    try {
        console.log("Fetching BS Reports with params: ", action.payload);
        const response = yield call(fetchBsReportsApi, action.payload);   
        const data = response?.data;
        console.log("BS Reports Data: ", data);
        yield put(bsReportsSuccess({ data }));
    } catch (error) {
        yield put(bsReportsFailure({ error: error.message }));
    }
}

export function* watchBsReportsSaga() {
    yield takeLatest(bsReportsStart.type, fetchBsReportsWorker);
}